<app-scroll-to-top />

<ng-container>
  <ipo-flexible-table
    [dataSet]="projects | filterByProperties: inputSearch() : filterFields"
    [columns]="columns | translateArray: (language$ | async)! : 'header'"
  >
    <ng-template [ipoTableColumn]="'starredCol'" let-project>
      <app-starred-button
        [starred]="project.starred"
        (clickStar)="handleClickStarButton(project)"
      />
    </ng-template>

    <ng-template [ipoTableColumn]="'ifsCol' | translate" let-project>
      {{ project.value && project.value }}
    </ng-template>

    <ng-template [ipoTableColumn]="'nameCol' | translate" let-project>
      {{ project.projectName ?? '-' }}
    </ng-template>

    <ng-template [ipoTableColumn]="'shaftCol' | translate" let-project>
      @if (!project.spans) {
        <ipo-skeleton [color]="'darker'" />
      } @else {
        {{ project.spans.performed }}/{{ project.spans.planned }}
      }
    </ng-template>

    <ng-template [ipoTableColumn]="'hPCol' | translate" let-project>
      @if (!project.distributionPoints) {
        <ipo-skeleton [color]="'darker'" />
      } @else {
        {{ project.distributionPoints.housePassed.performed }}/{{
          project.distributionPoints.housePassed.planned
        }}
      }
    </ng-template>

    <ng-template [ipoTableColumn]="'versionCol' | translate" let-project>
      @if (!project.version) {
        <ipo-skeleton [color]="'darker'" />
      } @else {
        v.{{ project.version.current }}
      }
    </ng-template>

    <ng-template [ipoTableColumn]="'statusCol' | translate" let-project>
      @if (!project.version) {
        <ipo-skeleton [color]="'darker'" />
      } @else {
        @if (
          project.version.current === project.version.lastPublished &&
          project.version.lastPublished !== '0'
        ) {
          <ipo-tag [variant]="'outline'">
            {{ 'table.published' | translate }}
          </ipo-tag>
        }
        @if (
          project.version.current !== project.version.lastPublished ||
          project.version.current === '0'
        ) {
          <ipo-tag [variant]="'outline'" [color]="'gamma'">
            {{ 'table.notPublished' | translate }}
          </ipo-tag>
        }
      }
    </ng-template>

    <ng-template [ipoTableColumn]="'completeCol'" let-project>
      <div class="button-wrapper">
        @if (
          project.completedResourceResponse &&
          project.completedResourceResponse.completedDate
        ) {
          <gc-tag [icon]="'circleCheck'" class="completed-date-tag">
            {{
              project.completedResourceResponse.completedDate
                | date: 'yyyy-MM-dd'
            }}
          </gc-tag>
        } @else if (activeTab === 1) {
          <gc-button
            [size]="'small'"
            (clicked)="handleClickCompleteProject(project)"
          >
            {{ 'table.completeProject' | translate }}
          </gc-button>
        }
      </div>
    </ng-template>
  </ipo-flexible-table>
</ng-container>

@if (isModalOpen()) {
  <app-project-completion-modal />
}
